import {
    formationWithOptionSlugType,
    formationWithoutOptionSlugType,
    fundingKindType,
    masterSlugType,
} from './types';

const formationWithOptionsMapping: Record<
    formationWithOptionSlugType,
    {
        title: string;
        dates: Array<{ label: string; value: string; isPast?: boolean }>;
        prices: { auto: number; other: number };
    }
> = {
    // Rubrique : BIODIVERSITÉ ET ÉCOLOGIE
    JARDIN_BIODIVERSITE_2026_2027: {
        dates: [{ label: '9 & 10 SEPTEMBRE 2026', value: '2026-09-09' }],
        prices: { auto: 380, other: 575 },
        title: 'Jardin et biodiversité',
    },
    FAUNE_2026_2027: {
        dates: [{ label: '24 & 25 SEPTEMBRE 2026', value: '2026-09-24' }],
        prices: { auto: 380, other: 575 },
        title: 'La faune, alliée des jardins vivants',
    },
    EAU_FRAICHEUR_URBAINE_2026_2027: {
        dates: [{ label: '22 & 23 OCTOBRE 2026', value: '2026-10-22' }],
        prices: { auto: 380, other: 575 },
        title: 'Eau et fraîcheur urbaine',
    },
    SOLS_BIODIVERSITE_2026_2027: {
        dates: [{ label: '12 & 13 NOVEMBRE 2026', value: '2026-11-12' }],
        prices: { auto: 380, other: 575 },
        title: 'Sols et biodiversité',
    },
    VEGETALISER_VILLE_2026_2027: {
        dates: [{ label: '13 & 14 JANVIER 2027', value: '2027-01-13' }],
        prices: { auto: 380, other: 575 },
        title: 'Végétaliser la ville',
    },
    GESTION_ECOLOGIQUE_2026_2027: {
        dates: [{ label: '25 NOVEMBRE 2026', value: '2026-11-25' }],
        prices: { auto: 190, other: 295 },
        title: 'Gestion écologique',
    },
    EVALUER_IMPACT_ENVIRONNEMENTAL_2026_2027: {
        dates: [{ label: '27 NOVEMBRE 2026', value: '2026-11-27' }],
        prices: { auto: 190, other: 295 },
        title: 'Évaluer l’impact environnemental',
    },
    ECONOMIE_CIRCULAIRE_REEMPLOI_2026_2027: {
        dates: [{ label: '23 AVRIL 2027', value: '2027-04-23' }],
        prices: { auto: 190, other: 295 },
        title: 'Économie circulaire et réemploi',
    },
    // Conception et métier
    IA_CONCEPTION_PAYSAGE_2026_2027: {
        title: 'I.A. et conception de paysage',
        dates: [{ label: 'DU 26 AU 30 OCTOBRE 2026', value: '2026-10-26' }],
        prices: { auto: 690, other: 990 },
    },
    IA_GESTION_ADMINISTRATIVE_2026_2027: {
        dates: [{ label: '22 OCTOBRE 2026', value: '2026-10-22' }],
        prices: { auto: 190, other: 295 },
        title: 'I.A. et gestion administrative',
    },
    IA_APPEL_OFFRE_2026_2027: {
        dates: [{ label: '23 OCTOBRE 2026', value: '2026-10-23' }],
        prices: { auto: 190, other: 295 },
        title: "I.A. et appels d'offres",
    },
    MODELISATION_3D_2026_2027: {
        dates: [{ label: 'DU 5 AU 21 OCTOBRE 2026', value: '2026-10-05' }],
        prices: { auto: 990, other: 1290 },
        title: 'Modélisation 3D (L.I.M.)',
    },
    SIG_PAYSAGE_2026_2027: {
        dates: [{ label: '1er & 2 OCTOBRE 2026', value: '2026-10-01' }],
        prices: { auto: 380, other: 575 },
        title: 'S.I.G. et paysage',
    },
    PLU_PAYSAGE_2026_2027: {
        dates: [{ label: '28 JANVIER 2027', value: '2027-01-28' }],
        prices: { auto: 190, other: 295 },
        title: 'P.L.U. et paysage',
    },

    //Rubrique Initiation au paysage
    CONCEVOIR_JARDIN_PRIVE_2026_2027: {
        prices: { auto: 100, other: 295 },
        title: 'Concevoir son jardin privé',
        dates: [{ label: '12 SEPTEMBRE 2026', value: '2026-09-12' }],
    },
    HISTOIRE_JARDINS_2026_2027: {
        prices: { auto: 100, other: 295 },
        title: 'Histoire des jardins',
        dates: [{ label: '24 AVRIL 2027', value: '2027-04-24' }],
    },
};

const formationWithOptionBundles: Array<{
    options: Array<formationWithOptionSlugType>;
    prices: { auto: number; other: number };
}> = [];

const formationWithoutOptionsMapping: Record<formationWithoutOptionSlugType, { title: string }> = {
    ENTRETIEN_ESPACE_VERT_2026_2027: {
        title: 'Entretien des espaces verts (1 jour - disponible uniquement en intra)',
    },
    ALTERNATIVES_ARROSAGE_2026_2027: {
        title: "Alternatives à l'arrosage (1 jour - disponible uniquement en intra)",
    },
    REALISER_UN_MASSIF_2026_2027: {
        title: 'Réaliser un massif (1 jour - disponible uniquement en intra)',
    },
};

const masterMapping: Record<masterSlugType, { title: string; price: number; description: string }> =
    {
        MASTER1: {
            title: "Master Paysagiste - première année (réservé aux personnes titulaires d'un diplôme niveau licence)",
            description: 'Formation sur 2 ans. Coût de la deuxième année : 5 754 €.',
            price: 8922,
        },
    };

const fundingMapping: Record<fundingKindType, { label: string }> = {
    auto: { label: 'Auto-financement' },
    company: { label: 'Entreprise' },
    opco: { label: 'OPCO' },
    vivea: { label: 'VIVEA' },
    'france-travail': { label: 'France Travail' },
};
export {
    fundingMapping,
    formationWithOptionsMapping,
    formationWithoutOptionsMapping,
    formationWithOptionBundles,
    masterMapping,
};
